import BaseComponent from "../components/BaseComponent";
import {
    FormItem,
    FormLayout,
    Input,
    Header,
    Switch,
    Div, SimpleCell, List, Cell, Title, Textarea, DateInput
} from "@vkontakte/vkui";
import {AddressSuggestions} from "react-dadata";
import React from "react";
import IMask from "imask";
import {AdaptivityContext} from "../assets/constants";
import axios from "axios";

class CheckoutDeliveryAddress extends BaseComponent {

    constructor(props) {
        super(props);
        const state = {
            items: [],
            loading: false
        }
        this.state = {
            ...this.state,
            ...state
        }
        this.addressRef = React.createRef();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.addressRef.current && this.props.address) {
            this.addressRef.current.setInputValue(this.props.address);
        }
    }

    componentDidMount() {
        super.componentDidMount();
        if (this.addressRef.current && this.props.address) {
            this.addressRef.current.setInputValue(this.props.address);
        }


    }

    getItems = (mainSearch = '', append, page) => {

        this.setState({loading: true})


        append = append == undefined ? false : append


        if (mainSearch == undefined) {
            mainSearch = this.state.mainSearch
        }

        if (page == undefined) {
            page = this.state.page;
        }


        let body = new FormData()
        body.append('group', '')
        body.append('sSearch', mainSearch)
        body.append('page', page)
        body.append('epp', AdaptivityContext.isMobile ? 14 : 16)
        const params_json = JSON.stringify([{param_id: 133, values:[501]}])
        body.append('params', params_json)

        axios.post(this.props.base_url + '?app=partnersproducts&act=searchProducts', body,
            {
                withCredentials: true

            }
        ).then((response) => {
            // console.log(response)

            this.setState({totalItems: response.data.total});
            this.setState({totalPages: response.data.totalPages});
            this.setState({Alfavit: response.data.Alfavit});
            this.setState({parent_group_id: response.data.parent_group_id});
            let old = this.state.items;


            if (!append) {
                old = response.data.results
            } else {
                response.data.results.map((el, i) => {
                    old.push(el)
                })
            }

            this.setState({items: old, loading: false});
            this.setState({path: response.data.path});

        })

    }
    handleChange = (field, value) => {
        if (this.props.onChange) {
            this.props.onChange(field, value);

            if (field == 'enabled' && value) {
                const self = this
                setTimeout(() => {
                    const phoneInput = document.getElementById("delivery_phone")
                    phoneInput.value = self.props.phone ?? ''

                    const phoneMask = new IMask(phoneInput, {
                        mask: "+{7}(000)000-00-00",
                    })


                    const listener = () => {

                        if (phoneMask.unmaskedValue[1] == '8') {
                            phoneMask.unmaskedValue = '7'
                            phoneMask.value = phoneMask.unmaskedValue;
                        }
                        self.handleChange('phone', {
                            phoneValid: phoneMask.masked.isComplete,
                            phone: phoneMask.unmaskedValue
                        })

                    }
                    phoneInput.addEventListener('input', listener)
                    listener()
                }, 1000)
                this.getItems()
            }
        }
    }

    handleAddressChange = (suggestion) => {
        this.handleChange('address', suggestion);
    }

    handleInputChange = (event, field) => {
        this.handleChange(field, event.target.value);


    }

    render() {
        const {
            title = "Доставка Вашему клиенту",
            note,
            phone,
            firstname,
            lastname,
            clientDate,
            enabled = false,
            errors = {}
        } = this.props;

        return (
            <div className={enabled ? 'active-checkout-delivery-address' : ''}>
                <FormLayout>
                    <FormItem>

                        <SimpleCell Component="label"
                                    after={<Switch checked={enabled}
                                                   onChange={(e) => this.handleChange('enabled', e.target.checked)}
                                    />}
                        >
                            {title}
                        </SimpleCell>
                    </FormItem>
                </FormLayout>

                {enabled &&
                    <div><FormLayout>
                        <FormItem
                            top="Адрес доставки"
                            status={errors.address ? 'error' : ''}
                            bottom={errors.address}
                        >
                            <AddressSuggestions
                                ref={this.addressRef}
                                onChange={this.handleAddressChange}
                                token="5367f393d0040cdc339492986bea8f13ebeec2a5"
                                inputProps={{
                                    placeholder: "Введите адрес доставки"
                                }}
                            />
                        </FormItem>

                        <FormItem
                            top="Имя клиента"
                            status={errors.firstName ? 'error' : ''}
                            bottom={errors.firstName}
                        >
                            <Input
                                type="text"
                                value={firstname || ''}
                                onChange={(e) => this.handleInputChange(e, 'firstname')}
                                placeholder="Введите имя клиента"
                            />
                        </FormItem>

                        <FormItem
                            top="Фамилия клиента"
                            status={errors.lastName ? 'error' : ''}
                            bottom={errors.lastName}
                        >
                            <Input
                                type="text"
                                value={lastname || ''}
                                onChange={(e) => this.handleInputChange(e, 'lastname')}
                                placeholder="Введите фамилию клиента"
                            />
                        </FormItem>

                        <FormItem
                            top="Телефон клиента"
                            status={errors.phone ? 'error' : ''}
                            bottom={errors.phone}
                        >
                            <Input
                                type="tel"
                                tabIndex="0"
                                id="delivery_phone"
                                placeholder="999 99-99"

                            />
                        </FormItem>
                        <FormItem
                            top="Примечания"
                            status={errors.note ? 'error' : ''}
                            bottom={errors.note}
                        >
                            <Textarea
                                value={note || ''}
                                onChange={(e) => this.handleInputChange(e, 'note')}
                            />
                        </FormItem>

                        <FormItem
                            top="Дата доставки клиента"
                            status={errors.clientDate ? 'error' : ''}
                            bottom={errors.clientDate}
                        >
                            <DateInput
                                value={clientDate || undefined}
                                onChange={(date) => this.handleChange('client_date', date)}
                                disablePast={true}
                            />
                        </FormItem>

                        <FormItem
                            top="Выберите тариф доставки"
                            status={errors.tariff ? 'error' : ''}
                            bottom={errors.tariff}
                        >
                            <List>
                                {!this.state.loading && Array.isArray(this.state.items)
                                    && this.state.items.length === 0 &&
                                    <SimpleCell key={'deliveryRow' + 0}>Ничего не найдено</SimpleCell>}
                                {this.state.items.map((item, index) =>
                                    <SimpleCell key={'deliveryRow' + index}
                                                onClick={e => {
                                                    e.stopPropagation();
                                                    this.setDeliveryTariff(!item.checked, item, index)
                                                }}
                                                after={<Switch
                                                    onChange={e => {
                                                        e.stopPropagation();
                                                        this.setDeliveryTariff(!item.checked, item, index)
                                                    }}
                                                    checked={item.checked}/>}>{item.name}</SimpleCell>
                                )}
                            </List>
                        </FormItem>
                    </FormLayout>
                    </div>
                }
            </div>
        )
    }

    setDeliveryTariff = (checked, item, index) => {
        const old = this.state.items[index]
        const {items} = this.state
        items.map(el => el.checked = false)
        old.checked = checked
        items[index] = old

        this.setState({items})
        this.handleChange('tariff', checked ? old : null)
    }
}

export default CheckoutDeliveryAddress; 